
















import { Component, Vue } from 'vue-property-decorator';
import ServiceRequestDetails from '../ServiceRequestDetails.vue';
import '../../assets/css/ServiceRequestDetails.scss';
@Component({
    components: {
        ServiceRequestDetails,
    },
    props: {
        requestId: String,
    },
})
export default class ViewRequestDetailModal extends Vue {

    private show = true;
    private id: string = '';

    private mounted() {
        this.id = this.$route.params.id || this.$props.requestId;
    }

    private close() {
        if (this.$props.requestId) {
            this.show = false;
            this.$emit('close');
        } else {
            this.$router.back();
        }
    }
}
